import { z } from "zod";
/* The curated iron supplement/medicine catalog. A product list, not client
 * data -- no per-client state lives in this file.
 *
 * No derived field anywhere in this file, and there must not be one added:
 * no ranking, score, badge, or "recommended" flag (root CLAUDE.md, "the
 * software does not interpret"; REQ-MDR-002). Sort order is expressed by
 * array position alone, and that position is editorial/alphabetical, never
 * clinical -- see 037_supplement_catalog.sql.
 */
export const supplementKindSchema = z.enum(["supplement", "medicine", "iv_iron"]);
export const supplementFormSchema = z.enum([
    "tablet",
    "capsule",
    "liquid",
    "drops",
    "spray",
    "powder",
    "sachet",
    "injection",
]);
export const supplementProductSchema = z.object({
    id: z.string(),
    name: z.string(),
    brand: z.string().nullable(),
    kind: supplementKindSchema,
    prescriptionOnly: z.boolean(),
    form: supplementFormSchema.nullable(),
    ironCompound: z.string().nullable(),
    elementalIronMg: z.number().nullable(),
    unitLabel: z.string().nullable(),
    containsVitaminC: z.boolean(),
    // Which supplement question lists the product (iron vs. everything else).
    category: z.enum(["iron", "other"]),
});
export const supplementCatalogResponseSchema = z.object({
    products: z.array(supplementProductSchema),
});
